actions:
  about: 關於
  background: 背景
  drag-position: 拖曳位置
  hearing: 語音辨識
  outfits: 穿搭
  view: 視角
  wardrobe: 衣櫃
background:
  title: 背景
  loading: 載入中...
  empty: 沒有可用的背景
  transparent: 透明
  blur: 模糊
  video: 影片
  upload-image: 上傳圖片
  upload-video: 上傳影片
  custom-image: 自訂圖片
  custom-video: 自訂影片
chat:
  actions:
    retry: Retry
  message:
    character-name:
      airi: MoeMoe
      core-system: 核心系統
      you: 你
  reasoning: 推理
  sessions:
    title: 對話
    new: + 新增
    empty: 目前還沒有對話
    cloud-badge: 已同步至雲端
    new-chat-fallback: 新對話
    delete: 刪除對話
message: 說點什麼...
send-mode:
  title: 傳送按鍵
  enter: Enter
  ctrl-enter: Ctrl + Enter
  double-enter: Enter + Enter
operations:
  load-models: 載入模型
  load-models-status:
    loading: 模型載入中
    ready: 已就緒
select-a-audio-input: 選擇一個音訊輸入裝置
select-a-model: 選擇一個模型
select-a-voice: 選擇一個聲線
viewers:
  debug-menu:
    emotions: 表情
    emotions-btn:
      angry: '😠 生氣'
      awkward: '😳 尷尬'
      happy: '😄 開心'
      neutral: '🙂 日常'
      question: '🤔 疑問'
      sad: '😫 難過'
      surprised: '🤯 驚喜'
      think: '🤨 思考'
    vrm:
      camera: 攝影機
      model:
        title: 模型
character-card:
  button: 角色
  title: 選擇角色
  subtitle: 選擇要聊天的角色
  empty: 目前沒有角色
  loading: 正在載入角色...
  load-more: 載入更多
  no-more: 全部都載入完了
  pull-to-load-more: 上拉以載入更多
  release-to-load: 放開即可載入更多
  loading-more: 正在載入更多...
  apply: 套用
  applied: 使用中
  local-section: 我的角色卡
  remote-section: 可使用的角色
download-app:
  button: 下載 App
  aria: 下載 Android 客戶端
language-switcher:
  button: 語言
  title: 選擇語言
membership:
  title: 會員
  upgrade: 升級至進階版
profile-switcher:
  no-profile: 無設定檔
  no-profiles: 暫時沒有設定檔
  save-as-new: 儲存為新設定檔
  new-profile-name: 設定檔名稱
  manage: 管理設定檔
promo-banner:
  items:
    signin:
      watermark: 月
      fallbackLabel: 月亮贈禮
      title: 7日簽到
      eventName: 簽到即可領取星塵、頭像框與開服好禮。
      date: 03/28 - 04/10
      reward: 最多 120 星塵
      cta: 立即簽到
    build:
      watermark: 建造
      fallbackLabel: 建造獎勵
      title: 補給箱獎勵
      eventName: 完成建造任務可獲得額外兌換券與雙倍材料。
      date: 03/30 - 04/12
      reward: 補給券 5 張 + 升級材料
      cta: 查看任務
    spring:
      watermark: 春天
      fallbackLabel: 春日抽抽樂
      title: 扭蛋嘉年華
      eventName: 參加春日抽抽樂，解鎖泡泡、吊飾與主題家具。
      date: 04/01 - 04/18
      reward: 首抽半價 + 稀有吊飾
      cta: 立即抽獎
    coupon:
      watermark: 暢聊
      fallbackLabel: 優惠券
      title: 儲值優惠券
      eventName: 完成聊天互動即可領取擴充包與語音包優惠券。
      date: 04/02 - 04/20
      reward: 滿 30 折 6 / 滿 68 折 15
      cta: 領取優惠券
    home:
      watermark: 居家
      fallbackLabel: 房間主題
      title: 春季主題更新
      eventName: 解鎖窗戶、書桌與小夜燈主題，讓房間煥然一新。
      date: 04/05 - 04/22
      reward: 簽到送主題抽獎券
      cta: 查看主題
waiting: 等待中
websocket-status:
  connected: 已連線
  disconnected: 未連線
  open-settings: 開啟連線設定
